import { RootState } from '@app/redux/root-reducer';

export const selectIsAuthenticated = (store: RootState) => Boolean(store.commonReducer.token);

export const selectAuthToken = (store: RootState) => store.commonReducer.token;

export const selectRecentViewedRecipes = (state: RootState) =>
    state.commonReducer.recentViewedRecipes || [];
